import { render } from "./TotalSumm.vue?vue&type=template&id=7dddcba0&scoped=true"
import script from "./TotalSumm.vue?vue&type=script&lang=js"
export * from "./TotalSumm.vue?vue&type=script&lang=js"

import "./TotalSumm.vue?vue&type=style&index=0&id=7dddcba0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dddcba0"]])

export default __exports__